import { action, observable } from 'mobx'
import { ASSIGNEE_TYPE, WARNING_MESSAGE } from '../constants'
import { DeparmentRequest } from '../requests/DepartmentRequest'
import { UserGroupRequest } from '../requests/UserGroupRequest'
import authenticationStore from './authenticationStore'
import { message } from 'antd'

class SelectPeopleStore {
  @observable departmentWithUserList = []
  @observable originDepartmentWithUserList = []
  @observable originGroupList = []
  @observable groupList = []
  @observable selectPopupName = 'Bảng chọn'
  @observable assigneePopupType = null
  @observable companyCode = null
  @observable selectGroupMemberData = []

  @observable checkDocument = false // check xem co phai la chon nguoi dung trong van ban den, di hay khong
  @observable setCheckDocument = type => {
    this.checkDocument = type
  }
  @observable checkCurrentAction = false
  @observable setCheckCurrentAction = type => {
    this.checkCurrentAction = type
  }

  @observable setSelectGroupMemberData = type => {
    this.selectGroupMemberData = type
  }

  @observable clearSelectGroupMemberData = () => {
    this.selectGroupMemberData = []
  }

  @observable setAssigneePopupType = type => {
    this.assigneePopupType = type
    if (!type) {
      this.selectPopupName = 'Bảng chọn người dùng'
    }
  }

  @observable paramDepartmentSort = 'department-asc, position-asc, username-asc'

  @action getDepartmentWithUsers = () => {
    return new Promise((resolve, reject) => {
      DeparmentRequest.getDepartmentWithUsers(
        this.paramDepartmentSort,
        this.companyCode
      )
        .then(response => {
          this.departmentWithUserList = response.data
          this.originDepartmentWithUserList = response.data
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }
  @action getDepartmentWithUsersV2 = () => {
    return new Promise((resolve, reject) => {
      DeparmentRequest.getDepartmentWithUsersV2()
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }
  @action setDepartmentWithUserList = newList => {
    this.departmentWithUserList = newList
  }

  @action getGroupList = (groupType, companyCode = this.companyCode) => {
    return new Promise((resolve, reject) => {
      UserGroupRequest.getGroupList(
        0,
        1000,
        undefined,
        groupType,
        companyCode
      )
        .then(response => {
          const groupListCustom = response.data.data.map(group => ({
            ...group,
            users: [],
          }))
          this.originGroupList = groupListCustom
          this.groupList = groupListCustom
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }
  @action setGroupList = newList => {
    this.groupList = newList
  }
  @action getMemberGroup = id_group => {
    return new Promise((resolve, reject) => {
      UserGroupRequest.getMemberGroupByIdGroup(id_group, 0, 100)
        .then(response => {
          const resultGroupList = this.originGroupList.map(group =>
            group.id !== id_group
              ? group
              : {
                  ...group,
                  users: response.data.data,
                }
          )
          this.originGroupList = resultGroupList
          this.groupList = resultGroupList
          resolve(response.data.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  @observable selectUserData = {
    [ASSIGNEE_TYPE.HANDLER]: [],
    [ASSIGNEE_TYPE.COMBINER]: [],
    [ASSIGNEE_TYPE.FOLLOWER]: [],
    [ASSIGNEE_TYPE.LEADER]: [],
    [ASSIGNEE_TYPE.CREATE]: [],
    [ASSIGNEE_TYPE.USER]: [],
    [ASSIGNEE_TYPE.UNIT_LEADER]: [],
    [ASSIGNEE_TYPE.KT_KTNB]: [],
    [ASSIGNEE_TYPE.HDQT]: [],
    [ASSIGNEE_TYPE.lanh_dao_vimc]: [],
    [ASSIGNEE_TYPE.ban_kt_ktnb]: [],
    [ASSIGNEE_TYPE.ban_pc_qtrr_ban_kt_ktnb_vimc]: [],
    [ASSIGNEE_TYPE.nddpv_vimc]: [],
    [ASSIGNEE_TYPE.dvpt_vimc]: [],
    [ASSIGNEE_TYPE.dv_cqvp_vimc]: [],
    [ASSIGNEE_TYPE.ban_dieu_hanh_hdqt_vimc]: [],
    [ASSIGNEE_TYPE.tgd_ptgd]: [],
    [ASSIGNEE_TYPE.ban_kt_ktnb_vimc]: [],
    [ASSIGNEE_TYPE.hdqt_vimc]: [],
    [ASSIGNEE_TYPE.ban_dieu_hanh]: [],
    [ASSIGNEE_TYPE.ban_pc_qtrr_vimc]: [],
    [ASSIGNEE_TYPE.ban_cmnv_vimc]: [],
    [ASSIGNEE_TYPE.lanh_dao_ban]: [],
    [ASSIGNEE_TYPE.don_vi_thuc_hien_xu_ly_rui_ro_3]: [],
    [ASSIGNEE_TYPE.cqvp_I]: [],
    [ASSIGNEE_TYPE.chuyen_vien_thuc_hien_cqvp_tuyen1]: [],
    [ASSIGNEE_TYPE.DEPARTMENT_APPROVER]: [],
    [ASSIGNEE_TYPE.FORM_APPROVER]: [],
    [ASSIGNEE_TYPE.KTAT_OFFICE]: [],
    [ASSIGNEE_TYPE.LEAD_KTAT_OFFICE]: [],
    [ASSIGNEE_TYPE.BOARD_OF_DIRECTOR]: [],
    [ASSIGNEE_TYPE.LEADER_APPROVER]: [],
    [ASSIGNEE_TYPE.NUMBER_ISSUER]: [],
    [ASSIGNEE_TYPE.DIGITAL_SIGNER]: [],
    [ASSIGNEE_TYPE.RELEASER]: [],
    [ASSIGNEE_TYPE.DEPARTMENT_CO_SIGNER]: [],
  }
  @action setSelectUserData = payloadSelect => {
    this.selectUserData = payloadSelect
  }
  @action clearSelectUserData = permissionType => {
    if (!permissionType) {
      this.selectUserData = {
        [ASSIGNEE_TYPE.HANDLER]: [],
        [ASSIGNEE_TYPE.COMBINER]: [],
        [ASSIGNEE_TYPE.FOLLOWER]: [],
        [ASSIGNEE_TYPE.LEADER]: [],
        [ASSIGNEE_TYPE.CREATE]: [],
        [ASSIGNEE_TYPE.USER]: [],
        [ASSIGNEE_TYPE.UNIT_LEADER]: [],
        [ASSIGNEE_TYPE.KT_KTNB]: [],
        [ASSIGNEE_TYPE.HDQT]: [],
        [ASSIGNEE_TYPE.lanh_dao_vimc]: [],
        [ASSIGNEE_TYPE.ban_kt_ktnb]: [],
        [ASSIGNEE_TYPE.ban_pc_qtrr_ban_kt_ktnb_vimc]: [],
        [ASSIGNEE_TYPE.nddpv_vimc]: [],
        [ASSIGNEE_TYPE.dvpt_vimc]: [],
        [ASSIGNEE_TYPE.dv_cqvp_vimc]: [],
        [ASSIGNEE_TYPE.ban_dieu_hanh_hdqt_vimc]: [],
        [ASSIGNEE_TYPE.tgd_ptgd]: [],
        [ASSIGNEE_TYPE.ban_kt_ktnb_vimc]: [],
        [ASSIGNEE_TYPE.hdqt_vimc]: [],
        [ASSIGNEE_TYPE.ban_dieu_hanh]: [],
        [ASSIGNEE_TYPE.ban_pc_qtrr_vimc]: [],
        [ASSIGNEE_TYPE.ban_cmnv_vimc]: [],
        [ASSIGNEE_TYPE.lanh_dao_ban]: [],
        [ASSIGNEE_TYPE.don_vi_thuc_hien_xu_ly_rui_ro_3]: [],
        [ASSIGNEE_TYPE.cqvp_I]: [],
        [ASSIGNEE_TYPE.chuyen_vien_thuc_hien_cqvp_tuyen1]: [],
        [ASSIGNEE_TYPE.DEPARTMENT_APPROVER]: [],
        [ASSIGNEE_TYPE.FORM_APPROVER]: [],
        [ASSIGNEE_TYPE.KTAT_OFFICE]: [],
        [ASSIGNEE_TYPE.LEAD_KTAT_OFFICE]: [],
        [ASSIGNEE_TYPE.BOARD_OF_DIRECTOR]: [],
        [ASSIGNEE_TYPE.LEADER_APPROVER]: [],
        [ASSIGNEE_TYPE.NUMBER_ISSUER]: [],
        [ASSIGNEE_TYPE.DIGITAL_SIGNER]: [],
        [ASSIGNEE_TYPE.RELEASER]: [],
        [ASSIGNEE_TYPE.DEPARTMENT_CO_SIGNER]: [],
      }
    } else {
      this.selectUserData = {
        ...this.selectUserData,
        [permissionType]: [],
      }
    }
  }

  @observable selectDepartmentData = {
    [ASSIGNEE_TYPE.HANDLER]: [],
    [ASSIGNEE_TYPE.COMBINER]: [],
    [ASSIGNEE_TYPE.FOLLOWER]: [],
    [ASSIGNEE_TYPE.LEADER]: [],
    [ASSIGNEE_TYPE.CREATE]: [],
    [ASSIGNEE_TYPE.USER]: [],
    [ASSIGNEE_TYPE.UNIT_LEADER]: [],
    [ASSIGNEE_TYPE.KT_KTNB]: [],
    [ASSIGNEE_TYPE.HDQT]: [],
    [ASSIGNEE_TYPE.lanh_dao_vimc]: [],
    [ASSIGNEE_TYPE.ban_kt_ktnb]: [],
    [ASSIGNEE_TYPE.ban_pc_qtrr_ban_kt_ktnb_vimc]: [],
    [ASSIGNEE_TYPE.nddpv_vimc]: [],
    [ASSIGNEE_TYPE.dvpt_vimc]: [],
    [ASSIGNEE_TYPE.dv_cqvp_vimc]: [],
    [ASSIGNEE_TYPE.ban_dieu_hanh_hdqt_vimc]: [],
    [ASSIGNEE_TYPE.tgd_ptgd]: [],
    [ASSIGNEE_TYPE.ban_kt_ktnb_vimc]: [],
    [ASSIGNEE_TYPE.hdqt_vimc]: [],
    [ASSIGNEE_TYPE.ban_dieu_hanh]: [],
    [ASSIGNEE_TYPE.ban_pc_qtrr_vimc]: [],
    [ASSIGNEE_TYPE.ban_cmnv_vimc]: [],
    [ASSIGNEE_TYPE.lanh_dao_ban]: [],
    [ASSIGNEE_TYPE.don_vi_thuc_hien_xu_ly_rui_ro_3]: [],
    [ASSIGNEE_TYPE.cqvp_I]: [],
    [ASSIGNEE_TYPE.chuyen_vien_thuc_hien_cqvp_tuyen1]: [],
    [ASSIGNEE_TYPE.DEPARTMENT_APPROVER]: [],
    [ASSIGNEE_TYPE.FORM_APPROVER]: [],
    [ASSIGNEE_TYPE.KTAT_OFFICE]: [],
    [ASSIGNEE_TYPE.LEAD_KTAT_OFFICE]: [],
    [ASSIGNEE_TYPE.BOARD_OF_DIRECTOR]: [],
    [ASSIGNEE_TYPE.LEADER_APPROVER]: [],
    [ASSIGNEE_TYPE.NUMBER_ISSUER]: [],
    [ASSIGNEE_TYPE.DIGITAL_SIGNER]: [],
    [ASSIGNEE_TYPE.RELEASER]: [],
    [ASSIGNEE_TYPE.DEPARTMENT_CO_SIGNER]: [],
  }
  @action setSelectDepartmentData = payloadSelect => {
    this.selectDepartmentData = payloadSelect
  }
  @action clearSelectDepartmentData = permissionType => {
    if (!permissionType) {
      this.selectDepartmentData = {
        [ASSIGNEE_TYPE.HANDLER]: [],
        [ASSIGNEE_TYPE.COMBINER]: [],
        [ASSIGNEE_TYPE.FOLLOWER]: [],
        [ASSIGNEE_TYPE.LEADER]: [],
        [ASSIGNEE_TYPE.CREATE]: [],
        [ASSIGNEE_TYPE.USER]: [],
        [ASSIGNEE_TYPE.UNIT_LEADER]: [],
        [ASSIGNEE_TYPE.KT_KTNB]: [],
        [ASSIGNEE_TYPE.HDQT]: [],
        [ASSIGNEE_TYPE.lanh_dao_vimc]: [],
        [ASSIGNEE_TYPE.ban_kt_ktnb]: [],
        [ASSIGNEE_TYPE.ban_pc_qtrr_ban_kt_ktnb_vimc]: [],
        [ASSIGNEE_TYPE.nddpv_vimc]: [],
        [ASSIGNEE_TYPE.dvpt_vimc]: [],
        [ASSIGNEE_TYPE.dv_cqvp_vimc]: [],
        [ASSIGNEE_TYPE.ban_dieu_hanh_hdqt_vimc]: [],
        [ASSIGNEE_TYPE.tgd_ptgd]: [],
        [ASSIGNEE_TYPE.ban_kt_ktnb_vimc]: [],
        [ASSIGNEE_TYPE.hdqt_vimc]: [],
        [ASSIGNEE_TYPE.ban_dieu_hanh]: [],
        [ASSIGNEE_TYPE.ban_pc_qtrr_vimc]: [],
        [ASSIGNEE_TYPE.ban_cmnv_vimc]: [],
        [ASSIGNEE_TYPE.lanh_dao_ban]: [],
        [ASSIGNEE_TYPE.cqvp_I]: [],
        [ASSIGNEE_TYPE.don_vi_thuc_hien_xu_ly_rui_ro_3]: [],
        [ASSIGNEE_TYPE.chuyen_vien_thuc_hien_cqvp_tuyen1]: [],
        [ASSIGNEE_TYPE.DEPARTMENT_APPROVER]: [],
        [ASSIGNEE_TYPE.FORM_APPROVER]: [],
        [ASSIGNEE_TYPE.KTAT_OFFICE]: [],
        [ASSIGNEE_TYPE.LEAD_KTAT_OFFICE]: [],
        [ASSIGNEE_TYPE.BOARD_OF_DIRECTOR]: [],
        [ASSIGNEE_TYPE.LEADER_APPROVER]: [],
        [ASSIGNEE_TYPE.NUMBER_ISSUER]: [],
        [ASSIGNEE_TYPE.DIGITAL_SIGNER]: [],
        [ASSIGNEE_TYPE.RELEASER]: [],
        [ASSIGNEE_TYPE.DEPARTMENT_CO_SIGNER]: [],
      }
    } else {
      this.selectDepartmentData = {
        ...this.selectDepartmentData,
        [permissionType]: [],
      }
    }
  }

  @observable selectGroupData = {
    [ASSIGNEE_TYPE.HANDLER]: [],
    [ASSIGNEE_TYPE.COMBINER]: [],
    [ASSIGNEE_TYPE.FOLLOWER]: [],
    [ASSIGNEE_TYPE.LEADER]: [],
    [ASSIGNEE_TYPE.CREATE]: [],
    [ASSIGNEE_TYPE.USER]: [],
    [ASSIGNEE_TYPE.UNIT_LEADER]: [],
    [ASSIGNEE_TYPE.KT_KTNB]: [],
    [ASSIGNEE_TYPE.HDQT]: [],
    [ASSIGNEE_TYPE.lanh_dao_vimc]: [],
    [ASSIGNEE_TYPE.ban_kt_ktnb]: [],
    [ASSIGNEE_TYPE.tgd_ptgd]: [],
    [ASSIGNEE_TYPE.ban_kt_ktnb_vimc]: [],
    [ASSIGNEE_TYPE.hdqt_vimc]: [],
    [ASSIGNEE_TYPE.ban_dieu_hanh]: [],
    [ASSIGNEE_TYPE.ban_pc_qtrr_vimc]: [],
    [ASSIGNEE_TYPE.ban_cmnv_vimc]: [],
    [ASSIGNEE_TYPE.lanh_dao_ban]: [],
    [ASSIGNEE_TYPE.don_vi_thuc_hien_xu_ly_rui_ro_3]: [],
    [ASSIGNEE_TYPE.chuyen_vien_thuc_hien_cqvp_tuyen1]: [],
    [ASSIGNEE_TYPE.DEPARTMENT_APPROVER]: [],
    [ASSIGNEE_TYPE.FORM_APPROVER]: [],
    [ASSIGNEE_TYPE.KTAT_OFFICE]: [],
    [ASSIGNEE_TYPE.LEAD_KTAT_OFFICE]: [],
    [ASSIGNEE_TYPE.BOARD_OF_DIRECTOR]: [],
    [ASSIGNEE_TYPE.LEADER_APPROVER]: [],
    [ASSIGNEE_TYPE.NUMBER_ISSUER]: [],
    [ASSIGNEE_TYPE.DIGITAL_SIGNER]: [],
    [ASSIGNEE_TYPE.RELEASER]: [],
    [ASSIGNEE_TYPE.DEPARTMENT_CO_SIGNER]: [],
  }
  @action setSelectGroupData = payloadSelect => {
    this.selectGroupData = payloadSelect
  }
  @action clearSelectGroupData = permissionType => {
    if (!permissionType) {
      this.selectGroupData = {
        [ASSIGNEE_TYPE.HANDLER]: [],
        [ASSIGNEE_TYPE.COMBINER]: [],
        [ASSIGNEE_TYPE.FOLLOWER]: [],
        [ASSIGNEE_TYPE.LEADER]: [],
        [ASSIGNEE_TYPE.CREATE]: [],
        [ASSIGNEE_TYPE.USER]: [],
        [ASSIGNEE_TYPE.UNIT_LEADER]: [],
        [ASSIGNEE_TYPE.KT_KTNB]: [],
        [ASSIGNEE_TYPE.HDQT]: [],
        [ASSIGNEE_TYPE.lanh_dao_vimc]: [],
        [ASSIGNEE_TYPE.ban_kt_ktnb]: [],
        [ASSIGNEE_TYPE.tgd_ptgd]: [],
        [ASSIGNEE_TYPE.ban_kt_ktnb_vimc]: [],
        [ASSIGNEE_TYPE.hdqt_vimc]: [],
        [ASSIGNEE_TYPE.ban_dieu_hanh]: [],
        [ASSIGNEE_TYPE.ban_pc_qtrr_vimc]: [],
        [ASSIGNEE_TYPE.ban_cmnv_vimc]: [],
        [ASSIGNEE_TYPE.lanh_dao_ban]: [],
        [ASSIGNEE_TYPE.cqvp_I]: [],
        [ASSIGNEE_TYPE.don_vi_thuc_hien_xu_ly_rui_ro_3]: [],
        [ASSIGNEE_TYPE.chuyen_vien_thuc_hien_cqvp_tuyen1]: [],
        [ASSIGNEE_TYPE.DEPARTMENT_APPROVER]: [],
        [ASSIGNEE_TYPE.FORM_APPROVER]: [],
        [ASSIGNEE_TYPE.KTAT_OFFICE]: [],
        [ASSIGNEE_TYPE.LEAD_KTAT_OFFICE]: [],
        [ASSIGNEE_TYPE.BOARD_OF_DIRECTOR]: [],
        [ASSIGNEE_TYPE.LEADER_APPROVER]: [],
        [ASSIGNEE_TYPE.NUMBER_ISSUER]: [],
        [ASSIGNEE_TYPE.DIGITAL_SIGNER]: [],
        [ASSIGNEE_TYPE.RELEASER]: [],
        [ASSIGNEE_TYPE.DEPARTMENT_CO_SIGNER]: [],
      }
    } else {
      this.selectGroupData = {
        ...this.selectGroupData,
        [permissionType]: [],
      }
    }
  }

  @observable isVisibleSelectUserDepartmentPopup = false
  @observable setIsVisibleSelectUserDepartmentPopup = bool => {
    this.isVisibleSelectUserDepartmentPopup = bool
  }
  @observable isVisibleSelectGroupPopup = false
  @observable setIsVisibleSelectGroupPopup = bool => {
    this.isVisibleSelectGroupPopup = bool
  }

  @action handleOpenSelectUserDepartmentPopup = popupType => {
    this.isVisibleSelectUserDepartmentPopup = true
    this.assigneePopupType = popupType
  }

  @action handleCancelSelectUserDepartment = () => {
    this.isVisibleSelectUserDepartmentPopup = false
    // this.assigneePopupType = null
  }
  @action handleRemoveSelectUserDepartment = () => {
    this.selectUserData = {
      ...this.selectUserData,
      [this.assigneePopupType]: [],
    }
    this.selectDepartmentData = {
      ...this.selectDepartmentData,
      [this.assigneePopupType]: [],
    }
  }

  @action handleOpenSelectGroupPopup = popupType => {
    this.isVisibleSelectGroupPopup = true
    this.assigneePopupType = popupType
  }
  @action handleCancelSelectGroup = () => {
    this.isVisibleSelectGroupPopup = false
    // this.selectGroupData = {
    //   ...this.selectGroupData,
    //   [this.assigneePopupType]: [],
    // }
    // this.assigneePopupType = null
  }
  @action handleRemoveSelectGroup = () => {
    this.selectGroupData = {
      ...this.selectGroupData,
      [this.assigneePopupType]: [],
    }
  }

  @action handleRemoveSelect = async item => {
    // Map assignee_type với key trong store
    const dataMap = {
      [ASSIGNEE_TYPE.USER]: 'selectUserData',
      [ASSIGNEE_TYPE.DEPARTMENT]: 'selectDepartmentData',
      [ASSIGNEE_TYPE.GROUP]: 'selectGroupData',
    }

    const key = dataMap[item.assignee_type]
    const isValidAssignee = Boolean(key)

    if (this.checkDocument) {
      // Kiểm tra quyền xóa
      const canDelete =
        item.create_user === authenticationStore.currentUser.username ||
        (this.checkCurrentAction
          ? isValidAssignee
          : item.assignee_type === ASSIGNEE_TYPE.GROUP)

      if (!canDelete) {
        message.warning(WARNING_MESSAGE.WARNING_DOCUMENT)
        this.checkDocument = false
        return
      }

      this.checkDocument = false
    }

    // Xóa dữ liệu
    if (key && this[key]?.[item.permission]) {
      this[key] = {
        ...this[key],
        [item.permission]: this[key][item.permission].filter(
          el => el.id !== item.id
        ),
      }
    }
  }

  @action convertSelectDataList = userList => {
    if (!userList || userList.length === 0) return []
    return userList.map(assign => {
      const result = {
        id: assign.assignee_code,
        assignee_type: assign.assignee_type,
        full_name: assign.name_uppercase,
        image_id: assign.image,
        permission: assign.permission,
        department_code: undefined,
        department_name: undefined,
        create_user: assign?.create_user ?? null,
      }
      this.originDepartmentWithUserList.forEach(department => {
        if (
          department.users.find(user => user.user_name === assign.assignee_code)
        ) {
          result.department_code = department.code
          result.department_name = department.name
        }
      })
      return result
    })
  }

  @action convertSelectDataObj = dataList => ({
    [ASSIGNEE_TYPE.HANDLER]: this.convertSelectDataList(dataList).filter(
      el => el.permission === ASSIGNEE_TYPE.HANDLER
    ),
    [ASSIGNEE_TYPE.COMBINER]: this.convertSelectDataList(dataList).filter(
      el => el.permission === ASSIGNEE_TYPE.COMBINER
    ),
    [ASSIGNEE_TYPE.FOLLOWER]: this.convertSelectDataList(dataList).filter(
      el => el.permission === ASSIGNEE_TYPE.FOLLOWER
    ),
    [ASSIGNEE_TYPE.LEADER]: this.convertSelectDataList(dataList).filter(
      el => el.permission === ASSIGNEE_TYPE.LEADER
    ),
    [ASSIGNEE_TYPE.CREATE]: this.convertSelectDataList(dataList).filter(
      el => el.permission === ASSIGNEE_TYPE.CREATE
    ),
    [ASSIGNEE_TYPE.USER]: this.convertSelectDataList(dataList).filter(
      el => el.permission === ASSIGNEE_TYPE.USER
    ),
    [ASSIGNEE_TYPE.UNIT_LEADER]: this.convertSelectDataList(dataList).filter(
      el => el.permission === ASSIGNEE_TYPE.UNIT_LEADER
    ),
    [ASSIGNEE_TYPE.KT_KTNB]: this.convertSelectDataList(dataList).filter(
      el => el.permission === ASSIGNEE_TYPE.KT_KTNB
    ),
    [ASSIGNEE_TYPE.HDQT]: this.convertSelectDataList(dataList).filter(
      el => el.permission === ASSIGNEE_TYPE.HDQT
    ),
    [ASSIGNEE_TYPE.lanh_dao_vimc]: this.convertSelectDataList(dataList).filter(
      el => el.permission === ASSIGNEE_TYPE.lanh_dao_vimc
    ),
    [ASSIGNEE_TYPE.ban_kt_ktnb]: this.convertSelectDataList(dataList).filter(
      el => el.permission === ASSIGNEE_TYPE.ban_kt_ktnb
    ),
    [ASSIGNEE_TYPE.tgd_ptgd]: this.convertSelectDataList(dataList).filter(
      el => el.permission === ASSIGNEE_TYPE.tgd_ptgd
    ),
    [ASSIGNEE_TYPE.ban_kt_ktnb_vimc]: this.convertSelectDataList(
      dataList
    ).filter(el => el.permission === ASSIGNEE_TYPE.ban_kt_ktnb_vimc),
    [ASSIGNEE_TYPE.hdqt_vimc]: this.convertSelectDataList(dataList).filter(
      el => el.permission === ASSIGNEE_TYPE.hdqt_vimc
    ),
    [ASSIGNEE_TYPE.ban_dieu_hanh]: this.convertSelectDataList(dataList).filter(
      el => el.permission === ASSIGNEE_TYPE.ban_dieu_hanh
    ),
    [ASSIGNEE_TYPE.ban_pc_qtrr_vimc]: this.convertSelectDataList(
      dataList
    ).filter(el => el.permission === ASSIGNEE_TYPE.ban_pc_qtrr_vimc),
    [ASSIGNEE_TYPE.ban_cmnv_vimc]: this.convertSelectDataList(dataList).filter(
      el => el.permission === ASSIGNEE_TYPE.ban_cmnv_vimc
    ),
    [ASSIGNEE_TYPE.lanh_dao_ban]: this.convertSelectDataList(dataList).filter(
      el => el.permission === ASSIGNEE_TYPE.lanh_dao_ban
    ),
    [ASSIGNEE_TYPE.don_vi_thuc_hien_xu_ly_rui_ro_3]: this.convertSelectDataList(
      dataList
    ).filter(
      el => el.permission === ASSIGNEE_TYPE.don_vi_thuc_hien_xu_ly_rui_ro_3
    ),
    [ASSIGNEE_TYPE.cqvp_I]: this.convertSelectDataList(dataList).filter(
      el => el.permission === ASSIGNEE_TYPE.cqvp_I
    ),
    [ASSIGNEE_TYPE.chuyen_vien_thuc_hien_cqvp_tuyen1]: this.convertSelectDataList(
      dataList
    ).filter(
      el => el.permission === ASSIGNEE_TYPE.chuyen_vien_thuc_hien_cqvp_tuyen1
    ),
    [ASSIGNEE_TYPE.DEPARTMENT_APPROVER]: this.convertSelectDataList(
      dataList
    ).filter(el => el.permission === ASSIGNEE_TYPE.DEPARTMENT_APPROVER),
    [ASSIGNEE_TYPE.FORM_APPROVER]: this.convertSelectDataList(dataList).filter(
      el => el.permission === ASSIGNEE_TYPE.FORM_APPROVER
    ),
    [ASSIGNEE_TYPE.KTAT_OFFICE]: this.convertSelectDataList(dataList).filter(
      el => el.permission === ASSIGNEE_TYPE.KTAT_OFFICE
    ),
    [ASSIGNEE_TYPE.LEAD_KTAT_OFFICE]: this.convertSelectDataList(
      dataList
    ).filter(el => el.permission === ASSIGNEE_TYPE.LEAD_KTAT_OFFICE),
    [ASSIGNEE_TYPE.BOARD_OF_DIRECTOR]: this.convertSelectDataList(
      dataList
    ).filter(el => el.permission === ASSIGNEE_TYPE.BOARD_OF_DIRECTOR),
    [ASSIGNEE_TYPE.LEADER_APPROVER]: this.convertSelectDataList(
      dataList
    ).filter(el => el.permission === ASSIGNEE_TYPE.LEADER_APPROVER),
    [ASSIGNEE_TYPE.DIGITAL_SIGNER]: this.convertSelectDataList(dataList).filter(
      el => el.permission === ASSIGNEE_TYPE.DIGITAL_SIGNER
    ),
    [ASSIGNEE_TYPE.NUMBER_ISSUER]: this.convertSelectDataList(dataList).filter(
      el => el.permission === ASSIGNEE_TYPE.NUMBER_ISSUER
    ),
    [ASSIGNEE_TYPE.RELEASER]: this.convertSelectDataList(dataList).filter(
      el => el.permission === ASSIGNEE_TYPE.RELEASER
    ),
    [ASSIGNEE_TYPE.DEPARTMENT_CO_SIGNER]: this.convertSelectDataList(
      dataList
    ).filter(el => el.permission === ASSIGNEE_TYPE.DEPARTMENT_CO_SIGNER),
  })

  @action clearSelectPeopleStore = () => {
    this.departmentWithUserList.length = 0
    this.originDepartmentWithUserList.length = 0
    this.groupList.length = 0
    this.originGroupList.length = 0
    this.selectPopupName = 'Bảng chọn người dùng'
    this.assigneePopupType = null
    this.companyCode = null
    this.clearSelectUserData()
    this.clearSelectDepartmentData()
    this.clearSelectGroupData()
  }

  @action clearSelected = () => {
    this.clearSelectUserData()
    this.clearSelectDepartmentData()
    this.clearSelectGroupData()
    this.selectPopupName = 'Bảng chọn người dùng'
    this.assigneePopupType = null
  }

  @action clearSelectedByType = permissionType => {
    this.clearSelectUserData(permissionType)
    this.clearSelectDepartmentData(permissionType)
    this.clearSelectGroupData(permissionType)
  }
}

export default new SelectPeopleStore()
